import {React, ReactDOM, WidgetApp, extend, _n, joinUrl, joinIfAbsent, hideModal, LEVEL_OVERLAY} from 'pexui';
import * as utils from '../utilities/utils';
import {track,trackClick,trackExit} from '../utilities/track';
import * as consts from '../models/consts';
import {flow, getTrackLabel, STATUS_COMPLETED} from '../models/flow';
import {InitPage} from './init';
import {IndexPage} from './index';
import {YodleePage} from './yodlee/yodlee';
import {ThankYouPage} from './thank';
import {YodleeSubmitPage} from './yodlee/yodleesubmit';
import YodleeOptOut from './yodlee/yodleeoptout';
import NovaPage from './nova/nova';
import {SubmitDialog, ExitConfirmDialog, ExitYodleeDialog} from './dialog';

export class GetInfoWidgetApp extends WidgetApp {
    constructor(props) {
        super(extend({
                id: consts.ELEM_ID_WIDGET,
                className: consts.CLASS_WIDGET
            }, props));
        this.addPage("init", InitPage);
        this.addPage("index", IndexPage);
        this.addPage("yodlee", YodleePage);
        this.addPage("yodleeSubmit", YodleeSubmitPage);
        this.addPage('yodleeOptOut', YodleeOptOut);
        this.addPage("thankyou", ThankYouPage);
        this.addPage("nova", NovaPage);

        this.state = {
            pageName: "init"
        };
    }

    showError(err){
        console.error(err);
    }

    closeWidget(){
        hideModal(LEVEL_OVERLAY);

        var elem = ReactDOM.findDOMNode(this);
        var parent = elem.parentNode;
        while(parent && parent.lastChild){
            parent.removeChild(parent.lastChild);
        }
    }

    allCompleted(){
        //status completed will only be true if it is yodlee only
        return STATUS_COMPLETED === flow.getReadyStatus();
    }

    onSubmit() {
        const doSubmit = ()=>{
            //for Yodlee-only, ThankYou has already been tracked.
            if(!flow.isYodleeOnly()){
                track("ThankYou", {
                    events: consts.SUCCESSFUL_COMPLETED_JOURNEY_EVENT
                });
            }

            flow.raiseInvokerEvent('submit', '');
            this.closeWidget();
        };

        if (this.allCompleted()) {
            doSubmit();
        }
        else{
            track("AYSSubmit");

            (<SubmitDialog/>)
                .show()
                .then(choice => {
                    if (choice === 'yes') {
                        //trackClick('Click_YesSubmit');
                        doSubmit();
                    }else{
                        trackClick('Click_NoGoBack');
                    }
            });
        }
    }

    onClose(){
        track("AYSExit", {contentName: getTrackLabel(flow.nodes && flow.nodes[0])});

        const exitDialog = flow.isYodleeOnly()? <ExitYodleeDialog/> : <ExitConfirmDialog/>;
        exitDialog.show()
            .then(choice => {
                if(choice === 'yes'){
                    trackExit();

                    flow.raiseInvokerEvent('fail', 'User cancelled');

                    this.closeWidget();
                }else{
                    trackClick('Click_NoGoBack');
                }
            });
    }

    getTextResourceUrl(){
        return '';
    }

}

GetInfoWidgetApp.propTypes = {
    config: React.PropTypes.object.isRequired,
    req: React.PropTypes.object.isRequired,
    widgetCallback: React.PropTypes.func.isRequired
};



// WEBPACK FOOTER //
// ./application/src/views/main_widget.jsx